// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import { FormFieldsFragmentDoc } from './common.generated';
import { FormSubmissionFieldsFragmentDoc } from './form-submissions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FormWithSubmissionFieldsFragment = { __typename?: 'FormWithSubmissions', is_completed?: boolean | null, form: { __typename?: 'Form', id: string, name: string, description?: string | null, outfitter_id: string, external_form_url?: string | null, is_published?: boolean | null, is_required?: boolean | null, should_create_lead_from_submission?: boolean | null, is_e_signature_required?: boolean | null, submissions_count?: number | null, success_redirect_url?: string | null, url?: string | null, created_by?: string | null, created_at: number, updated_at: number, link_to_booking_configs?: { __typename?: 'LinkToBookingConfigs', listings?: Array<string> | null, pricing_packages?: Array<string> | null, has_to_be_filled_per_member?: boolean | null } | null, form_inputs?: Array<{ __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null }> | null }, submissions: Array<{ __typename?: 'FormSubmission', id: string, form_id: string, booking_id?: string | null, user_id?: string | null, status: Types.FormSubmissionStatus, username?: string | null, url?: string | null, is_host_submission: boolean, created_at: number, updated_at: number, is_unread: boolean, user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, avatar_url?: string | null, created_at: number, is_admin?: boolean | null, is_developer?: boolean | null, bio: string, years_of_experience?: number | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null } | null, answers: Array<{ __typename?: 'FormSubmissionAnswer', input_id: string, value: { __typename?: 'FormSubmissionAnswerValue', text_value?: string | null, text_list_value?: Array<string> | null, numeric_value?: number | null, boolean_value?: boolean | null, listing_ids?: Array<string> | null, pricing_package_ids?: Array<string> | null, media?: { __typename?: 'Media', url: string, description?: string | null, mime_type?: string | null, file_name?: string | null } | null } }>, form: { __typename?: 'Form', id: string, name: string, description?: string | null, outfitter_id: string, external_form_url?: string | null, is_published?: boolean | null, is_required?: boolean | null, should_create_lead_from_submission?: boolean | null, is_e_signature_required?: boolean | null, submissions_count?: number | null, success_redirect_url?: string | null, url?: string | null, created_by?: string | null, created_at: number, updated_at: number, link_to_booking_configs?: { __typename?: 'LinkToBookingConfigs', listings?: Array<string> | null, pricing_packages?: Array<string> | null, has_to_be_filled_per_member?: boolean | null } | null, form_inputs?: Array<{ __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null }> | null } }> };

export type CreateFormMutationVariables = Types.Exact<{
  data: Types.CreateFormInput;
  outfitterId: Types.Scalars['ID']['input'];
}>;


export type CreateFormMutation = { __typename?: 'Mutation', createForm: { __typename?: 'Form', id: string, name: string, description?: string | null, outfitter_id: string, external_form_url?: string | null, is_published?: boolean | null, is_required?: boolean | null, should_create_lead_from_submission?: boolean | null, is_e_signature_required?: boolean | null, submissions_count?: number | null, success_redirect_url?: string | null, url?: string | null, created_by?: string | null, created_at: number, updated_at: number, link_to_booking_configs?: { __typename?: 'LinkToBookingConfigs', listings?: Array<string> | null, pricing_packages?: Array<string> | null, has_to_be_filled_per_member?: boolean | null } | null, form_inputs?: Array<{ __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null }> | null } };

export type UpdateFormMutationVariables = Types.Exact<{
  data: Types.UpdateFormInput;
  id: Types.Scalars['ID']['input'];
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', updateForm: { __typename?: 'Form', id: string, name: string, description?: string | null, outfitter_id: string, external_form_url?: string | null, is_published?: boolean | null, is_required?: boolean | null, should_create_lead_from_submission?: boolean | null, is_e_signature_required?: boolean | null, submissions_count?: number | null, success_redirect_url?: string | null, url?: string | null, created_by?: string | null, created_at: number, updated_at: number, link_to_booking_configs?: { __typename?: 'LinkToBookingConfigs', listings?: Array<string> | null, pricing_packages?: Array<string> | null, has_to_be_filled_per_member?: boolean | null } | null, form_inputs?: Array<{ __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null }> | null } };

export type DeleteFormMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteFormMutation = { __typename?: 'Mutation', deleteForm: any };

export type DuplicateFormMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DuplicateFormMutation = { __typename?: 'Mutation', duplicateForm: { __typename?: 'Form', id: string, name: string, description?: string | null, outfitter_id: string, external_form_url?: string | null, is_published?: boolean | null, is_required?: boolean | null, should_create_lead_from_submission?: boolean | null, is_e_signature_required?: boolean | null, submissions_count?: number | null, success_redirect_url?: string | null, url?: string | null, created_by?: string | null, created_at: number, updated_at: number, link_to_booking_configs?: { __typename?: 'LinkToBookingConfigs', listings?: Array<string> | null, pricing_packages?: Array<string> | null, has_to_be_filled_per_member?: boolean | null } | null, form_inputs?: Array<{ __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null }> | null } };

export type FormsQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  text?: Types.InputMaybe<Types.Scalars['String']['input']>;
  paging: Types.Paging;
}>;


export type FormsQuery = { __typename?: 'Query', forms: { __typename?: 'PaginatedForms', count: number, pages: number, data: Array<{ __typename?: 'Form', id: string, name: string, description?: string | null, outfitter_id: string, external_form_url?: string | null, is_published?: boolean | null, is_required?: boolean | null, should_create_lead_from_submission?: boolean | null, is_e_signature_required?: boolean | null, submissions_count?: number | null, success_redirect_url?: string | null, url?: string | null, created_by?: string | null, created_at: number, updated_at: number, link_to_booking_configs?: { __typename?: 'LinkToBookingConfigs', listings?: Array<string> | null, pricing_packages?: Array<string> | null, has_to_be_filled_per_member?: boolean | null } | null, form_inputs?: Array<{ __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null }> | null }> } };

export type FormQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FormQuery = { __typename?: 'Query', form: { __typename?: 'Form', id: string, name: string, description?: string | null, outfitter_id: string, external_form_url?: string | null, is_published?: boolean | null, is_required?: boolean | null, should_create_lead_from_submission?: boolean | null, is_e_signature_required?: boolean | null, submissions_count?: number | null, success_redirect_url?: string | null, url?: string | null, created_by?: string | null, created_at: number, updated_at: number, link_to_booking_configs?: { __typename?: 'LinkToBookingConfigs', listings?: Array<string> | null, pricing_packages?: Array<string> | null, has_to_be_filled_per_member?: boolean | null } | null, form_inputs?: Array<{ __typename?: 'FormInput', id: string, input_type: Types.FormInputType, title: string, options?: Array<string> | null, placeholder?: string | null, is_required: boolean, additional_notes?: string | null, should_allow_pricing_package_selection?: boolean | null, order?: number | null }> | null } };

export const FormWithSubmissionFieldsFragmentDoc = gql`
    fragment FormWithSubmissionFields on FormWithSubmissions {
  form {
    ...FormFields
  }
  submissions {
    ...FormSubmissionFields
  }
  is_completed
}
    ${FormFieldsFragmentDoc}
${FormSubmissionFieldsFragmentDoc}`;
export const CreateFormDocument = gql`
    mutation createForm($data: CreateFormInput!, $outfitterId: ID!) {
  createForm(data: $data, outfitterId: $outfitterId) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const UpdateFormDocument = gql`
    mutation updateForm($data: UpdateFormInput!, $id: ID!) {
  updateForm(data: $data, id: $id) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, options);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const DeleteFormDocument = gql`
    mutation deleteForm($id: ID!) {
  deleteForm(id: $id)
}
    `;
export type DeleteFormMutationFn = Apollo.MutationFunction<DeleteFormMutation, DeleteFormMutationVariables>;

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormMutation, { data, loading, error }] = useDeleteFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormMutation, DeleteFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormMutation, DeleteFormMutationVariables>(DeleteFormDocument, options);
      }
export type DeleteFormMutationHookResult = ReturnType<typeof useDeleteFormMutation>;
export type DeleteFormMutationResult = Apollo.MutationResult<DeleteFormMutation>;
export type DeleteFormMutationOptions = Apollo.BaseMutationOptions<DeleteFormMutation, DeleteFormMutationVariables>;
export const DuplicateFormDocument = gql`
    mutation duplicateForm($id: ID!) {
  duplicateForm(id: $id) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type DuplicateFormMutationFn = Apollo.MutationFunction<DuplicateFormMutation, DuplicateFormMutationVariables>;

/**
 * __useDuplicateFormMutation__
 *
 * To run a mutation, you first call `useDuplicateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateFormMutation, { data, loading, error }] = useDuplicateFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateFormMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateFormMutation, DuplicateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateFormMutation, DuplicateFormMutationVariables>(DuplicateFormDocument, options);
      }
export type DuplicateFormMutationHookResult = ReturnType<typeof useDuplicateFormMutation>;
export type DuplicateFormMutationResult = Apollo.MutationResult<DuplicateFormMutation>;
export type DuplicateFormMutationOptions = Apollo.BaseMutationOptions<DuplicateFormMutation, DuplicateFormMutationVariables>;
export const FormsDocument = gql`
    query forms($outfitterId: ID!, $text: String, $paging: Paging!) {
  forms(outfitterId: $outfitterId, text: $text, paging: $paging) {
    count
    pages
    data {
      ...FormFields
    }
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useFormsQuery__
 *
 * To run a query within a React component, call `useFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormsQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      text: // value for 'text'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useFormsQuery(baseOptions: Apollo.QueryHookOptions<FormsQuery, FormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
      }
export function useFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormsQuery, FormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
        }
export type FormsQueryHookResult = ReturnType<typeof useFormsQuery>;
export type FormsLazyQueryHookResult = ReturnType<typeof useFormsLazyQuery>;
export type FormsQueryResult = Apollo.QueryResult<FormsQuery, FormsQueryVariables>;
export const FormDocument = gql`
    query form($id: ID!) {
  form(id: $id) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useFormQuery__
 *
 * To run a query within a React component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormQuery(baseOptions: Apollo.QueryHookOptions<FormQuery, FormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQuery, FormQueryVariables>(FormDocument, options);
      }
export function useFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuery, FormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQuery, FormQueryVariables>(FormDocument, options);
        }
export type FormQueryHookResult = ReturnType<typeof useFormQuery>;
export type FormLazyQueryHookResult = ReturnType<typeof useFormLazyQuery>;
export type FormQueryResult = Apollo.QueryResult<FormQuery, FormQueryVariables>;